"use client";

import { FC, useMemo } from "react";

import { ArticleRecord } from "@graphql/types/graphql";
import { getLink, isoToDateString } from "utils";

import { useLocale } from "next-intl";
import { Locale } from "consts/locale";
import { ImageTeaserHorizontal } from "./templates/ImageTeaserHorizontal";

interface Props {
  article: ArticleRecord;
  isHorizontal?: boolean;
  isHighlighted?: boolean;
}

export const ArticleTeaser: FC<Props> = ({ article, isHorizontal, isHighlighted }) => {
  const locale = useLocale() as Locale;

  const formattedDate = useMemo(
    () => isoToDateString(locale, article.date),
    [locale, article.date],
  );

  const articleLink = useMemo(() => getLink(article, locale), [article, locale]);

  return (
    <ImageTeaserHorizontal
      link={articleLink}
      image={article.introImage?.responsiveImage}
      tag={article.tag || undefined}
      title={article.title}
      description={article.shortIntro || article.intro}
      date={formattedDate}
      isHorizontal={isHorizontal}
      isHighlighted={isHighlighted}
    />
  );
};
